var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3DBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.59981 3.1354C10.4741 2.63061 10.9113 2.37821 11.3761 2.27942C11.7873 2.19201 12.2123 2.19201 12.6235 2.27942C13.0883 2.37821 13.5255 2.63061 14.3998 3.1354L18.4766 5.48912C19.3509 5.99391 19.7881 6.24631 20.106 6.59942C20.3873 6.91185 20.5998 7.27992 20.7297 7.67976C20.8766 8.13166 20.8766 8.63645 20.8766 9.64604V14.3535C20.8766 15.3631 20.8766 15.8679 20.7297 16.3198C20.5998 16.7197 20.3873 17.0877 20.106 17.4002C19.7881 17.7533 19.3509 18.0057 18.4766 18.5105L14.3998 20.8642C13.5255 21.369 13.0883 21.6214 12.6235 21.7202C12.2123 21.8076 11.7873 21.8076 11.3761 21.7202C10.9113 21.6214 10.4741 21.369 9.59981 20.8642L5.52305 18.5105C4.64872 18.0057 4.21155 17.7533 3.89361 17.4002C3.6123 17.0877 3.39979 16.7197 3.26988 16.3198C3.12305 15.8679 3.12305 15.3631 3.12305 14.3535V9.64604C3.12305 8.63645 3.12305 8.13166 3.26988 7.67976C3.39979 7.27992 3.6123 6.91185 3.89361 6.59942C4.21155 6.24631 4.64872 5.99391 5.52305 5.48912L9.59981 3.1354Z",
    stroke: "currentColor",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9994 11.9995L3.70703 7.21191M11.9994 11.9995L20.2917 7.21191M11.9994 11.9995L11.9995 21.5442",
    stroke: "currentColor",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DBox);
export default __webpack_public_path__ + "static/media/3d_box.78267f5ffdbec4b21f59a9472d31f7dc.svg";
export { ForwardRef as ReactComponent };